<template>
  <div 
    :class="[
      'skeleton-loader',
      className
    ]"
    :style="{
      width: width,
      height: height
    }"
  />
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '20px'
  },
  className: {
    type: String,
    default: 'bg-gray-200 dark:bg-gray-700'
  }
});
</script>

<style scoped>
.skeleton-loader {
  position: relative;
  overflow: hidden;
  background-color: var(--skeleton-base-color, rgba(0, 0, 0, 0.06));
  border-radius: 4px;
}

.skeleton-loader::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  animation: shimmer 2s infinite;
  content: '';
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

:root[data-theme="dark"] .skeleton-loader {
  --skeleton-base-color: rgba(255, 255, 255, 0.04);
}
</style>
